/** Tailwind `text-*` font-size tokens — keep in sync with tailwind.preset.js */
export const typographySizeTokens = [
  'display-xl',
  'display-lg',
  'display-section',
  'display-md',
  'headline',
  'card-title',
  'subhead',
  'nav',
  'body-lg',
  'body-reading',
  'body',
  'body-sm',
  'caption',
  'button',
  'micro',
  'eyebrow',
  'mono',
] as const;

/**
 * Semantic typography class names — mirrors docs/design/design-system.md
 * and docs/design/DESIGN-linear.app.md hierarchy.
 */
export const typography = {
  displayXl: 'text-display-xl',
  displayLg: 'text-display-lg',
  displaySection: 'text-display-section',
  displayMd: 'text-display-md',
  headline: 'text-headline',
  cardTitle: 'text-card-title',
  subhead: 'text-subhead',
  nav: 'text-nav',
  bodyLg: 'text-body-lg',
  bodyReading: 'text-body-reading',
  body: 'text-body',
  bodySm: 'text-body-sm',
  caption: 'text-caption',
  button: 'text-button',
  eyebrow: 'text-eyebrow',
  micro: 'text-micro',
  mono: 'text-mono font-mono',
} as const;

export type TypographyToken = keyof typeof typography;
